<script setup lang="ts">
import { storeToRefs } from "pinia";

import { TuiButton, TuiProgressSpinner } from "@vm/tui";
import { FormProvider } from "@vm/vue-core";

import ComparisonColorsConfig from "./comparison-colors-config.vue";
import ComparisonLayoutConfig from "./comparison-layout-config.vue";
import TypeColorsConfig from "./type-colors-config.vue";

import {
  type ComparisonSettings,
  useSettingsEditorStore,
} from "../use-settings-editor-store";

const emit = defineEmits<{
  submit: [];
}>();

const settingsEditorStore = useSettingsEditorStore();

const { settings, isInitialized } = storeToRefs(settingsEditorStore);
const { putSettings } = settingsEditorStore;

async function handleSubmit(newSettings: ComparisonSettings) {
  await putSettings(newSettings);
  emit("submit");
}
</script>

<template>
  <div v-if="!isInitialized" class="flex h-full items-center justify-center">
    <TuiProgressSpinner text="Loading settings..." />
  </div>

  <FormProvider v-else :form-data="settings" :on-submit="handleSubmit">
    <div class="flex flex-col gap-8 pb-8">
      <ComparisonColorsConfig />
      <TypeColorsConfig />
      <ComparisonLayoutConfig />
      <div class="flex justify-end">
        <TuiButton
          type="submit"
          label="Save configuration"
          severity="success"
        />
      </div>
    </div>
  </FormProvider>
</template>
